import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, { Autoplay, Parallax } from "swiper";
// 导入css动画效果
import CSSTrans from "@/components/CSSTrans";
import "@/assets/styles/animates.scss";
SwiperCore.use([Autoplay, Parallax]);
class Product extends Component {
  state = {
    mySwiper_product: null,
    allowSlidePrev: false, // swiper 向上
    allowSlideNext: true, // swiper 向下
    product_1_show: false,
    product_2_show: false,
  };
  componentDidMount() {
    this.props.componentRef(this, "product");
  }
  slideChange = (e) => {
    // console.log("product:" + e.realIndex);
    switch (e.realIndex) {
      case 0:
        this.setState({
          allowSlidePrev: false,
          allowSlideNext: true,
          product_1_show: true,
          product_2_show: false,
        });
        break;
      default:
        this.setState({
          allowSlidePrev: true,
          allowSlideNext: false,
          product_1_show: false,
          product_2_show: true,
        });
        break;
    }
  };
  setSwiper_product = (el) => {
    this.setState({
      mySwiper_product: el,
    });
  };
  //   跳转页面
  toSecondPage(e, page) {
    this.props.toSecondPage(page);
  }
  render() {
    const { allowSlidePrev, allowSlideNext } = this.state;
    const product_content = JSON.parse(this.props.product_content);
    return (
      <Swiper
        className="mySwiper_product"
        onSwiper={this.setSwiper_product}
        onSlideChange={this.slideChange}
        allowSlidePrev={allowSlidePrev}
        allowSlideNext={allowSlideNext}
        autoplay={{
          delay: 6000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        // loop={mySwiper_product_loop}
        keyboard={true}
        parallax={true}
        pagination={{
          clickable: true,
        }}
        style={{
          "--swiper-pagination-bullet-width": "8px",
          "--swiper-pagination-bullet-height": "8px",
          "--swiper-pagination-color": "#5ab5f0",
          "--swiper-pagination-bullet-inactive-color": "none",
          "--swiper-pagination-bullet-inactive-opacity": "1",
        }}
      >
        {/* <div
          slot="container-start"
          className="parallax-bg"
          data-swiper-parallax="-8%"
        ></div> */}
        <SwiperSlide>
          <div className="product_1">
            <div className="product_1_container">
              {CSSTrans(
                this.state.product_1_show,
                "fadeInUp_trans",
                <h1 className="title">{product_content[0].title}</h1>
              )}
              {CSSTrans(
                this.state.product_1_show,
                "fadeInUp_trans",
                <div className="content">{product_content[0].content}</div>
              )}
              {CSSTrans(
                this.state.product_1_show,
                "fadeInUp_trans",
                <div
                  className="more-btn"
                  onClick={(e) => this.toSecondPage(e, "CBU")}
                >
                  {product_content[0].btnText}
                </div>
              )}
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="product_1 product_2">
            <div className="product_1_container">
              {CSSTrans(
                this.state.product_2_show,
                "fadeInUp_trans",
                <h1 className="title">{product_content[1].title}</h1>
              )}
              {CSSTrans(
                this.state.product_2_show,
                "fadeInUp_trans",
                <div className="content">{product_content[1].content}</div>
              )}
              {CSSTrans(
                this.state.product_2_show,
                "fadeInUp_trans",
                <div
                  className="more-btn"
                  onClick={(e) => this.toSecondPage(e, "EBU")}
                >
                  {product_content[0].btnText}
                </div>
              )}
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    );
  }
}
export default Product;
